<template>
  <div class="hanrei">
    <div class="hanrei__red">
      <div class="hanrei__80"></div>
      <span class="hanrei__memori">More than 80%</span>
    </div>
    <div class="hanrei__beige">
      <div class="hanrei__50"></div>
      <span class="hanrei__memori">More than 50%</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Hanrei'
}
</script>

<style>
.hanrei {
  display: flex;
  justify-content: center;
}

.hanrei__red, .hanrei__beige {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  font-size: 15px;
}

.hanrei__beige {
  margin-left: 16px;
}

.hanrei__80 {
  width: 16px;
  height: 16px;
  background-color: #E5334B;
}

.hanrei__50 {
  width: 16px;
  height: 16px;
  background-color: #E18773;
}

.hanrei__memori{
  margin-left: 8px;
}
</style>
